import { render, staticRenderFns } from "./tabBookingFCLUICustom.vue?vue&type=template&id=0b99f3b4&scoped=true&"
import script from "./tabBookingFCLUICustom.vue?vue&type=script&lang=js&"
export * from "./tabBookingFCLUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabBookingFCLUICustom.vue?vue&type=style&index=0&id=0b99f3b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b99f3b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b99f3b4')) {
      api.createRecord('0b99f3b4', component.options)
    } else {
      api.reload('0b99f3b4', component.options)
    }
    module.hot.accept("./tabBookingFCLUICustom.vue?vue&type=template&id=0b99f3b4&scoped=true&", function () {
      api.rerender('0b99f3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCLUICustom.vue"
export default component.exports